import { createApp } from 'vue';
import App from './App.vue';
import './styles/widget.css';
import 'vue-tel-input/vue-tel-input.css';
import VueTelInput from 'vue-tel-input';
import type { BookingProvider } from './provider';

declare global {
  interface Window {
    MedfileBookingWidgetConfig?: {
      restUrl: string;
      tracking: unknown;
      i18n: Record<string, string>;
      additional: {
        termsUrl: string;
        privacyPolicyUrl: string;
        successMessage?: string;
        medchartSuccessMessage?: string;
      };
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll<HTMLElement>('.medfile-booking-widget');

  if (!containers.length) {
    return;
  }

  containers.forEach((el) => {
    const ds = el.dataset || {};

    const mode = (ds.mode as string) || 'mixed';
    const services = ds.services ? ds.services.split(',').map((s) => s.trim()).filter(Boolean) : [];
    const users = ds.users ? ds.users.split(',').map((s) => s.trim()).filter(Boolean) : [];
    const provider = (ds.provider === 'medchart' ? 'medchart' : 'medfile') as BookingProvider;

    const app = createApp(App, {
      restUrl: window.MedfileBookingWidgetConfig?.restUrl || '',
      mode,
      services,
      users,
      provider,
    });

    app.use(VueTelInput);

    app.mount(el);
  });
});
